import(/* webpackMode: "eager" */ "/github/workspace/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/github/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/github/workspace/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/github/workspace/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/github/workspace/node_modules/react-toastify/dist/ReactToastify.css");
